var CONSTANT_FIELDS, ResponseCreateMemberModal;

CONSTANT_FIELDS = [
  {
    id: -1,
    title: '姓名',
    type: 'Field::TextField',
    validations: ["presence"],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: '导入别名',
    type: 'Field::TextField',
    validations: [],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -3,
    title: '识别码',
    type: 'Field::TextField',
    validations: ["presence"],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -4,
    title: '手机号码',
    type: 'Field::Phone',
    validations: [],
    settings: {
      layout: null
    },
    _editing: true
  }
];

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import TagsSelect from 'trunks/vue/admin/compositions/tags_select.js';

export default ResponseCreateMemberModal = Vue.extend({
  components: {
    'modal': Modal,
    'field-list': FieldList,
    'Popover': Popover,
    'tags-select': TagsSelect
  },
  props: {
    title: {
      type: String,
      default: '新建成员'
    },
    createUserCallback: {
      type: Function
    },
    tagsRequestUrl: {
      type: String
    },
    initialSelectedTagIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    response: {
      type: Object,
      default: function() {
        return new Skylark.App.Model.Response();
      }
    },
    profileSchema: {
      type: Object,
      required: true
    },
    record: {
      type: Object
    }
  },
  data: function() {
    return {
      valid: true,
      tagGroups: [],
      selectedTagIds: this.initialSelectedTagIds
    };
  },
  computed: {
    fields: function() {
      return _.map(CONSTANT_FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    tags: function() {
      return _.reduce(this.tagGroups, function(memo, tag_group) {
        return memo.concat(tag_group.tags);
      }, []);
    },
    selectedTags: function() {
      return _.select(this.tags, (tag) => {
        return _.include(this.selectedTagIds, tag.id);
      });
    },
    displayValue: function() {
      return _.map(this.selectedTags, function(tag) {
        return tag.name;
      }).join('，');
    },
    profileResponse: function() {
      var ref;
      return new Skylark.App.Model.Response(_.extend({
        id: '_user_profile_response'
      }, (ref = this.record) != null ? ref.profile_submission : void 0));
    }
  },
  template: `<modal :title="title"
       :extendClass='"response-create-member-modal organization-modal"'
       ref="modal">
  <div class="modal-body">
    <div class="response-record">
      <field-list :fields='fields'
                  :response='response'
                  :entries='response.entries'
                  :editing='true'
                  extendClass='form-field-group field-list-two-item'
                  ref='fieldsView' />
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">成员标签</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <Popover position='bottom' :blockContent='true' :customClass='"tags-popover select"' ref="tagsSelectPopoverRef">
              <template slot='trigger'>
                <div class="input-control justify-box right-addon">
                  <div class="controlled-input" v-show='displayValue'>{{ displayValue }}</div>
                  <div class="controlled-input placeholder" v-show='!displayValue'>请选择</div>
                  <div class="addon">
                    <i class="slp-caret-down"></i>
                  </div>
                </div>
              </template>
              <template slot='content'>
                <tags-select :optionsUrl='tagsRequestUrl'
                             :initialSelectedTagIds='initialSelectedTagIds'
                             :needFooter="false"
                             @valueChanged="setSelectedOptionIds">
                </tags-select>
              </template>
            </Popover>
          </div>
        </div>
      </div>
      <field-list :fields='profileSchema.fields'
                  :response='profileResponse'
                  :entries='profileResponse.entries'
                  :editing='true'
                  ref='profileRef' />
    </div>
  </div>
  <div slot='footer' class="modal-footer">
    <button class="outlined btn-default" @click='cancel'>取消</button>
    <button @click='save'>确定</button>
  </div>
</modal>`,
  created: function() {
    return Skylark.Libs.Ajax.get(`/admin${this.tagsRequestUrl}`, {
      success: (data) => {
        return this.tagGroups = data;
      }
    });
  },
  methods: {
    save: function() {
      var data, entries, profileEntries;
      entries = this.$refs.fieldsView.getEntries();
      profileEntries = this.$refs.profileRef.getEntries();
      if (!(this.$refs.fieldsView.valid && this.$refs.profileRef.valid)) {
        return this.$refs.fieldsView._alertErrorContent('请检查您的输入项，必填字段不能为空');
      }
      data = _.reduce(entries, function(memo, entry) {
        switch (entry.field_id) {
          case -1:
            memo.name = entry.value;
            break;
          case -2:
            memo.nickname = entry.value;
            break;
          case -3:
            memo.identifier = entry.value;
            break;
          case -4:
            memo.phone = entry.value;
        }
        return memo;
      }, {});
      data['tag_ids'] = this.selectedTagIds;
      data['profile_submission_attributes'] = {
        entries_attributes: profileEntries
      };
      return this.createUserCallback({
        user: data
      });
    },
    setSelectedOptionIds: function(selectedOptionIds) {
      return this.selectedTagIds = selectedOptionIds;
    },
    open: function() {
      return this.$refs.modal.open();
    },
    cancel: function() {
      return this.$refs.modal.close();
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    },
    _getNewResponse: function() {
      return {
        response: {
          entries_attributes: this.$refs.fieldsView.getEntries()
        }
      };
    }
  }
});
